export default __webpack_public_path__ + "static/media/mechanic-3.37a9396f.jpg";